// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

export class MedicalBISiteOfCareAddress {
    'streetAddress'?: string;
    'streetAddressLine2'?: string;
    'city'?: string;
    'state'?: string;
    'zip'?: string;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof MedicalBISiteOfCareAddress>> = [
        {
            "name":     "streetAddress",
            "baseName": "streetAddress",
            "type":     "string"
        },
        {
            "name":     "streetAddressLine2",
            "baseName": "streetAddressLine2",
            "type":     "string"
        },
        {
            "name":     "city",
            "baseName": "city",
            "type":     "string"
        },
        {
            "name":     "state",
            "baseName": "state",
            "type":     "string"
        },
        {
            "name":     "zip",
            "baseName": "zip",
            "type":     "string"
        },
    ];

    static getAttributeTypeMap() {
        return MedicalBISiteOfCareAddress.attributeTypeMap;
    }
}
